module.exports = __webpack_public_path__ + "img/PARQUE.b71a66d1.png";